import React, { useEffect, useState } from 'react';
import { Button, Card, Table } from 'react-bootstrap';
import { useParams } from 'react-router';
import { AgencyService } from '../AgencyService';
import { toast } from 'react-toastify';
import { IPendingEmails } from '../dto/IPandingEmails';
import { formatDate } from '../../../utils/Functions';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { useDispatch } from 'react-redux';
import generalSlice from '../../../store/general/GeneralSlice';
import { ErrorToast } from '../../../utils/toasters';
import EmptyState from '../../../shared/components/EmptyState';

export function ListPendingEmails() {
    const [emails, setEmails] = useState<IPendingEmails[]>([]);
    const { agencyId } = useParams() as { agencyId: string };
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        AgencyService.getPendingEmails(+agencyId)
            .then(data => {
                setEmails(data);
            })
            .catch(err => ErrorToast(err))
            .finally(() => setIsLoading(false));
    }, []);

    const deleteEmailRequest = (emailId: number) => {
        AgencyService.deletePendingEmails(emailId)
            .then(data => {
                setEmails(data);
                dispatch(
                    generalSlice.actions.setConfirmModal({
                        show: false,
                    })
                );
                toast.success('Successfully deleted email');
            })
            .catch(err => ErrorToast(err));
    };

    return (
        <>
            <h2 className="subheader-title text-dark font-weight-bold my-2 mr-3">Pending emails</h2>

            {!isLoading && !emails.length ? (
                <EmptyState classHolder="mb-5" />
            ) : (
                <Card className="mb-5 p-4">
                    <Table hover responsive>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Requested date</th>
                                <th>Email</th>
                                <th>Exists</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {emails?.map(e => (
                                <tr key={e.id}>
                                    <td>{e.id}</td>
                                    <td>{formatDate(e.createdAt)}</td>
                                    <td>{e.email}</td>
                                    <td>
                                        {e?.isExisting ? (
                                            <span className="word-break text-primary">
                                                <FaCheck />
                                            </span>
                                        ) : (
                                            <span className="word-break text-danger">
                                                <FaTimes />
                                            </span>
                                        )}
                                    </td>
                                    <td className="text-left">
                                        <Button
                                            onClick={() => {
                                                dispatch(
                                                    generalSlice.actions.setConfirmModal({
                                                        show: true,
                                                        title: 'Agency communication',
                                                        contentBody: (
                                                            <div>Are you sure you want to remove this email?</div>
                                                        ),
                                                        action: () => deleteEmailRequest(e.id),
                                                    })
                                                );
                                            }}
                                            variant="danger"
                                            size="sm"
                                        >
                                            Delete email
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card>
            )}
        </>
    );
}
